export default {
    'menu.dashboard': '仪表盘',
    'menu.systemManagement': '系统管理',
    'menu.accountManagement': '账号管理',
    'menu.roleManagement': '角色管理',
};
